import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/NewPcButton';
import { useState } from 'react';
import { useOrderDetails } from '../../OrderDetailsProvider';

import { sellerQueries } from '@/api';
import { InputBox } from '@/components/atoms/InputBox';
import { useShippingCompanyPreference } from '@/pages/orders/_hooks/useShippingCompanyPreference';
import { useAppSelector } from '@/redux/store';
import { useQuery } from '@tanstack/react-query';
import Select from './Select';

export const DeclineCancelModal = ({
  open,
  onOpenChange,
  step,
  onNext,
  onSubmit,
  isProcessing,
  errorMsg,
  shippingCompanyList,
  shippingCompanyCode,
  setShippingCompanyCode,
  invoiceNo,
  setInvoiceNo,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  step: number;
  onNext: () => void;
  onSubmit: () => void;
  isProcessing: boolean;
  errorMsg: string | null;
  shippingCompanyList: any[];
  shippingCompanyCode: string;
  setShippingCompanyCode: (v: string) => void;
  invoiceNo: string;
  setInvoiceNo: (v: string) => void;
}) => {
  const user = useAppSelector((state) => state.user);

  const { shippingCompanyData } = useOrderDetails();
  const { handlePrefer } = useShippingCompanyPreference(shippingCompanyData);

  const { data } = useQuery(sellerQueries.getInfo({ cplatToken: user.CplatToken }));

  const dataList = data?.data[0].shippingCompanyList.map((item) => ({
    value: item.shippingCompanyCode,
    label: item.shippingCompanyName,
    isPrefer: item.isPrefer,
  }));

  const [isSelectOpen, setIsSelectOpen] = useState(false);

  return (
    <Dialog open={open}>
      <DialogContent noCloseBtn className="flex w-[380px] flex-col gap-0 p-[30px]">
        {step === 1 && (
          <>
            <div className="text-gr-900 Title3S18">판매자 주문 취소를 진행할게요</div>
            <div className="pl-5">
              <ul className="mt-[4px] list-disc text-gr-700 Body5M14">
                <li>
                  결제 완료 상품의 주문을 취소할 경우 마켓 정책에 따라
                  <br />
                  상품 품절로 인한 주문 거절로 사유가 등록돼요.
                  <br /> *각 마켓 정책에 따라 상품이 품절 상태로 변경될 수 있습니다.
                </li>
                <li className="mt-5">
                  기타 사유로 주문 취소가 필요할 경우 마켓 판매자 페이지에서 직접 처리를 진행해
                  주세요.
                </li>
              </ul>
            </div>
            <div className="mt-[29px] flex w-full gap-[10px]">
              <Button
                variant="secondary"
                className="h-[44px] flex-1"
                onClick={() => onOpenChange(false)}
              >
                닫기
              </Button>
              <Button className="flex-1" onClick={onNext}>
                확인
              </Button>
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <div className="text-gr-900 Title3S18">발송 정보 입력</div>
            <div className="mt-[4px] text-gr-700 Body5M14">
              구매자에게 상품 배송 시작으로 인한 취소 요청 거절로
              <br />
              안내되며, 배송중 상태로 보여져요.
            </div>
            <div className="mt-[20px]">
              <div className="mb-1 text-gr-800 Caption1M12">택배사</div>

              <Select
                className="h-[40px]"
                placeholder="택배사를 선택하세요"
                dataList={dataList ?? []}
                // selectedValue={setInvoiceWatch('shippingCompanyCode')}
                selectedValue={shippingCompanyCode}
                // onSelectedValueChange={(value) => setInvoiceSetValue('shippingCompanyCode', value)}
                onSelectedValueChange={(value) => setShippingCompanyCode(value)}
                onPreferChange={(code: string) => {
                  handlePrefer(code);
                }}
                open={isSelectOpen}
                onOpenChange={(open) => {
                  setTimeout(() => setIsSelectOpen(open), 100); // 닫기 클릭 방지
                }}
              />
              <div className="mb-1 mt-5 text-gr-800 Caption1M12">운송장 번호</div>
              {/* <input
                type="text"
                value={invoiceNo}
                onChange={(e) => setInvoiceNo(e.target.value.replace(/[^0-9a-zA-Z]/g, ''))}
                className="w-full rounded-[8px] border border-gr-300 px-[10px] py-[12px] text-gr-800 transition-colors Body5M14 focus:outline-none focus:ring-2 focus:ring-point-500"
                placeholder="운송장 번호를 입력하세요"
                maxLength={20}
              /> */}
              <InputBox
                type="text"
                value={invoiceNo}
                onChange={(e) => setInvoiceNo(e.target.value.replace(/[^0-9a-zA-Z]/g, ''))}
                className="w-full rounded-[8px] border border-gr-300 px-[10px] py-[12px] text-gr-800 transition-colors Body5M14 "
                placeholder="운송장 번호를 입력하세요"
                maxLength={20}
              />
              {errorMsg && <div className="Body5S14 mt-2 text-red-600">{errorMsg}</div>}
            </div>
            <div className="mt-[24px] flex w-full gap-[10px]">
              <Button
                variant="secondary"
                className="h-[44px] flex-1"
                onClick={() => onOpenChange(false)}
                disabled={isProcessing}
              >
                닫기
              </Button>
              <Button
                className="flex-1"
                onClick={onSubmit}
                disabled={!shippingCompanyCode || !invoiceNo || isProcessing}
              >
                발송처리
              </Button>
            </div>
          </>
        )}
        {step === 3 && (
          <>
            <div className="text-gr-900 Title3S18">유효하지 않은 운송장 번호에요</div>
            <div className="mt-[8px] text-gr-700 Body5M14">
              발송 정보를 확인 후, 유효한 운송장 번호를 입력해 주세요.
            </div>
            <Button
              variant="solid"
              className="mt-[24px] h-[44px] w-full"
              onClick={() => onOpenChange(false)}
            >
              확인
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
